/**
 * Decodifica JWT (apenas o payload, sem validação de assinatura)
 * @param {string} token - JWT no formato "header.payload.signature"
 * @returns {object|null} - Payload decodificado ou null se inválido
 */
export function decodeJWT(token) {
  if (!token || typeof token !== 'string') return null;

  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const payload = parts[1];
    const binary = atob(payload);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const decoded = JSON.parse(new TextDecoder('utf-8').decode(bytes));

    return decoded;
  } catch (error) {
    console.error('Erro ao decodificar JWT:', error);
    return null;
  }
}

/**
 * Extrai permissões do JWT
 * @param {string} token - JWT
 * @returns {string[]} - Array de permissões (ex: ['videos.view', 'diets.create'])
 */
export function getPermissionsFromToken(token) {
  const decoded = decodeJWT(token);
  if (!decoded) return [];

  // O backend Laravel coloca permissões em `permissions` no JWT
  const permissions = decoded.permissions || [];

  return Array.isArray(permissions) ? permissions : [];
}

/**
 * Extrai dados do usuário do JWT
 * @param {string} token - JWT
 * @returns {object|null} - Dados do user (id, name, email, role)
 */
export function getUserFromToken(token) {
  const decoded = decodeJWT(token);
  if (!decoded) return null;

  return {
    id: decoded.sub || decoded.user_id || null,
    name: decoded.name || null,
    email: decoded.email || null,
    role: decoded.role || null,
    isPlatformAdmin: decoded.is_platform_admin === true
  };
}

/**
 * Verifica se o usuário tem uma permissão específica
 * @param {string[]} userPermissions - Permissões do usuário
 * @param {string} requiredPermission - Permissão necessária
 * @returns {boolean}
 */
export function hasPermission(userPermissions, requiredPermission) {
  if (!Array.isArray(userPermissions)) return false;
  if (!requiredPermission) return true; // Sem permissão exigida = acesso livre

  return userPermissions.includes(requiredPermission);
}
